/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum QaLoginPage {
  inputEmail = 'login-page_email',
  inputPassword = 'login-page_password',
  buttonSignIn = 'login-page_signin',
  linkForgotPassword = 'login-page_forgot-password',
  textCustomerSupport = 'login-page_customer-support',
  textFooter = 'login-page_footer',
  linkTermsOfService = 'login-page_terms-of-service',
  linkPrivacyPolicy = 'login-page_privacy-policy',
  textTitle = 'login-page_text-title',
  textToastAlert = 'login-page_text-toast-alert',
}

export enum QaDashboardPage {
  inputSearch = 'dashboard-page_search',
  buttonUnlockVault = 'component-digital-vault_unlock',
  buttonCreateMasterPassword = 'component-digital-vault_button-create-master-password',
  textPageTitle = 'dashboard-page_text-page-title',

  // sidebar
  dropdownMoreFeatures = 'sidebar_more-features',
}

export enum QADashboardPageDboo {
  buttonActivate = 'dashboard-page-dboo_activate',
  buttonReview = 'dashboard-page-dboo_review',
  textOptOutsInProgress = 'dashboard-page-dboo_in-progress',
  textOptOutsSuccess = 'dashboard-page-dboo_success',

  // dashboard page -> dboo card
  cardDboo = 'dashboard-page_card-dboo',
  cardDbooTitle = 'dashboard-page_card-dboo-title',
  cardDbooDescription = 'dashboard-page_card-dboo-description',
}

export enum QaDbooComponent {
  buttonActivate = 'component-dboo_activate-opt-out',
  buttonReviewRequests = 'component-dboo_review-requests',
}

export enum QaDbooPage {
  textSuccessfulOptOuts = 'successful opt outs',
  textInProgressOptOuts = 'dboo-page_in-progress-opt-outs',
  textOptOutsCount = 'dboo-page_count-',
  textNextOptOut = 'next scheduled opt out',
  buttonDeactivateOptOut = 'dboo-page_deactivate-opt-out',
  buttonActivateOptOut = 'component-dboo_activate-opt-out',

  // 'Information required to activate Data Broker Opt Out' modal
  textModalActivateOptOutTitle = 'dboo-page_modal-activate-opt-out-title',
  textModalActivateOptOutDescription = 'dboo-page_modal-activate-opt-out-description',

  // 'Unblock now' modal
  textUnblockNowTitle = 'dboo-page_unblock-now-title',
  textUnblockNowDescription = 'dboo-page_unblock-now-description',
  textUnblockNowAlert = 'dboo-page_unblock-now-alert',
  buttonUnblockNowCancel = 'dboo-page_unblock-now-cancel',
  buttonUnblockNowSubmit = 'dboo-page_unblock-now-submit',

  buttonUnblock = 'dboo-page_unblock',
}

export enum QaDbooActivateModal {
  buttonPrevious = 'dboo-activate-modal_previous',
  buttonFinish = 'dboo-activate-modal_finish',

  // legal name
  inputFirstName = 'dboo-activate-modal_first-name',
  inputMiddleName = 'dboo-activate-modal_middle-name',
  inputLastName = 'dboo-activate-modal_last-name',
  dropdownSuffix = 'dboo-activate-modal_suffix',
  textTitleLegalName = 'dboo-activate-modal_title-legal-name',

  // dob, phone, ssn, email

  textTitleDob = 'dboo-activate-modal_title-dob',
  textTitleAddress = 'dboo-activate-modal_title-address',

  // checkbox
  checkbox = 'dboo-activate-modal_checkbox',
}

export enum QaDbooDeactivateModal {
  textHeader = 'dboo-deactivate-modal_header',
  textSubheader = 'dboo-deactivate-modal_subheader',
}

export enum QaPrivateSearchComponent {
  inputSearchTerm = 'component-private-search_search-term',
  buttonSubmitSearch = 'component-private-search_submit',
}

export enum QaMasterPasswordModal {
  inputMasterPassword = 'modal-master-password_input-password',
  buttonUnlock = 'modal-master-password_unlock',
  textErrorMessage = 'modal-master-password_error-message',
  textTitle = 'modal-master-password_text-title',
  linkForgotMasterPassword = 'modal-master-password_link-forgot-master-password',
  buttonCancel = 'modal-master-password_button-cancel',
}

export enum QaDigitalVault {
  buttonAddDocument = 'component-digital-vault_add-doc',
  textDocumentCount = 'component-digital-vault_doc-count',

  textTitleNoDocuments = 'component-digital-vault_title_no_documents',
  buttonSearchDocuments = 'component-digital-vault_search_documents',
  buttonClearSearch = 'component-digital-vault_clear_search',
  inputSearchDocuments = 'component-digital-vault_input_search_documents',
  buttonDocumentContainer = 'component-digital-vault_document-container',
  dropdownDocument = 'component-digital-vault_document-dropdown_',

  // document page
  textItemType = 'component-digital-vault_item-type',
  textItemName = 'component-digital-vault_item-name',
  textItemDescription = 'component-digital-vault_item-description',
  textAttachmentName = 'component-digital-vault_attachment-name_',
  textNoSearchResults = 'component-digital-vault_no_search_results',
  dropdownAttachment = 'component-digital-vault_attachment-dropdown_',

  // delete document modal
  buttonDocumentDelete = 'modal-delete-document_delete',

  // delete attachment modal
  buttonAttachmentDelete = 'modal-delete-attachment_delete',
}

export enum QaDigitalVaultAddDoc {
  inputTitle = 'modal-add-document_name',
  inputDescription = 'modal-add-document_description',
  buttonSaveInVault = 'modal-add-document_button-save-in-vault',
  buttonAddAttachment = 'modal-add-document_add-attachment',
  alertFileErrorMessage = 'modal-add-document_file-error-message',
  alertSelectItemError = 'modal-add-document_select-item-error-message',
}

export enum QaDigitalVaultEditDoc {
  inputDocName = 'modal-edit-doc_input-document-name',
  inputDocDescription = 'modal-edit-doc_input-document-description',
  buttonSaveChanges = 'modal-edit-document_button-save-changes',
}

export enum QaDarkWebMonitoringComponent {
  // personal information items
  buttonPersonalInfo = 'component-dwm_personal-info',
  buttonAddName = 'component-dwm_add-name',
  buttonAddDob = 'component-dwm_add-dob',
  buttonAddSsn = 'component-dwm_add-ssn',
  buttonAddMothersMaidenName = 'component-dwm_add-mothers-maiden-name',
  buttonAddEmail = 'component-dwm_add-email',
  buttonAddPhone = 'component-dwm_add-phone',
  buttonAddHomeAddress = 'component-dwm_add-home-address',
  buttonAddIpAddress = 'component-dwm_add-ip-address',

  // identification information items
  buttonIdentificationInfo = 'component-dwm_identification-info',
  buttonAddDriversLicense = 'component-dwm_add-drivers-license',
  buttonAddHealthInsurance = 'component-dwm_add-health-insurance',
  buttonAddPasspord = 'component-dwm_add-passport',
  buttonAddGreenCard = 'component-dwm_add-greencard',
  buttonAddTaxpayerId = 'component-dwm_add-taxpayer-id',
  buttonAddNpi = 'component-dwm_add-npi',

  // financial information items
  buttonFinancialInfo = 'component-dwm_financial-info',
  buttonAddCreditCard = 'component-dwm_add-credit-card',
  buttonAddFinancialAccount = 'component-dwm_add-financial-account',
  buttonAddLoyaltyCard = 'component-dwm_add-loyalty-card',

  // username items
  buttonUsername = 'component-dwm_username',
  buttonAddGamertag = 'component-dwm_add-gamertag',
  buttonAddFacebook = 'component-dwm_add-facebook',
  buttonAddInstagram = 'component-dwm_add-instagram',
  buttonAddPaypal = 'component-dwm_add-paypal',
  buttonAddTelegram = 'component-dwm_add-telegram',
  buttonAddTwitter = 'component-dwm_add-twitter',
  buttonAddVenmo = 'component-dwm_add-venmo',
  buttonAddYoutube = 'component-dwm_add-youtube',
  buttonAddOthers = 'component-dwm_add-others',

  // medical data
  buttonMedicalBeneficiary = 'component-dwm_medical-beneficiary',
  buttonMedicalRecordNumber = 'component-dwm_add-medical-record-number',

  // add dwm item modal
  buttonSave = 'component-dwm_save',
  inputMothersMaidenName = 'component-dwm_input-mothers-maiden-name',
  dropdownPhoneNumberType = 'component-dwm_dropdown-phone-number-type',
  inputHomeAddressStreet = 'component-dwm_input-home-address-street',
  inputHomeAddressApartment = 'component-dwm_input-home-address-apartment',
  inputNetworkIpAddress = 'component-dwm_input-network-ip-address',
  inputNetworkDeviceName = 'component-dwm_input-network-device-name',
  inputDriverLicenseNumber = 'component-dwm_input-driver-license-number',
  inputHealthInsuranceProviderName = 'component-dwm_input-health-insurance-provider-name',
  inputHealthInsuranceIdNumber = 'component-dwm_input-health-insurance-id-number',
  inputPassportNumber = 'component-dwm_input-passport',
  dropdownVisaDocumentType = 'component-dwm_dropdown-visa-document-type',
  inputVisaDocumentNumber = 'component-dwm_input-visa-document-number',
  inputTaxpayerIdentificationNumber = 'component-dwm_input-taxpayer-identification-number',
  inputNationalProviderIdentifier = 'component-dwm_input-national-provider-identifier',
  inputCreditCardNumber = 'component-dwm_input-credit-card-number',
  dropdownFinancialAccountType = 'component-dwm_dropdown-financial-account-type',
  inputFinancialAccountNumber = 'component-dwm_input-financial-account-number',
  inputLoyaltyCardName = 'component-dwm_input-loyalty-card-name',
  inputLoyaltyCardNumber = 'component-dwm_input-loyalty-card-number',
  inputGamertag = 'component-dwm_input-gamertag',
  inputFacebookUsername = 'component-dwm_input-facebook-username',
  inputInstagramUsername = 'component-dwm_input-instagram-username',
  inputPayPalUsername = 'component-dwm_input-paypal-username',
  inputTelegramUsername = 'component-dwm_input-telegram-username',
  inputTwitterHandle = 'component-dwm_input-twitter-handle',
  inputVenmoUsername = 'component-dwm_input-venmo-username',
  inputYouTubeHandle = 'component-dwm_input-youtube-handle',
  inputOtherAccountName = 'component-dwm_input-other-account-name',
  inputOtherUsername = 'component-dwm_input-other-username',
  inputHealthcareOrgName = 'component-dwm_input-healthcare-org-name',
  inputMedicalRecordNumber = 'component-dwm_input-medical-record-number',
  inputMedicalBeneficiaryId = 'component-dwm_input-medical-beneficiary-id',

  textModalDescription = 'component-dwm_text-modal-description',

  tooltipAddItem = 'component-dwm_tooltip-add-item',

  alertInputErrorMessage = 'component-dwm_alert-input-error-message',

  // remove dwm item modal
  buttonRemoveItem = 'component-dwm_button-remove-item-',
  buttonRemoveItemModalCancel = 'component-dwm_button-remove-item-modal-cancel',
  buttonRemoveItemModalCRemove = 'component-dwm_button-remove-item-modal-remove',

  // dashboard page -> dwm card
  buttonAddToWatchlist = 'component-dwm_card-button-add-to-watchlist',
}

export enum QaPasswordScanComponent {
  inputPassword = 'component-password-scan_input-password',
  buttonCheckPassword = 'component-password-scan_check-password',
  textPasswordScanResult = 'component-password-scan_scan-result',
  textTermsOfService = 'component-password-scan_terms-of-service',
  textErrorMessage = 'component-password-scan_error-message',
}

export enum QaCommonComponent {
  buttonContinue = 'component-common_button-continue',
  buttonCancel = 'component-common_button-cancel',
  buttonModalClose = 'button-modal-close',
  alertGlobalToast = 'global-toast-alert',
}

export enum QaHeader {
  dropdownProfileMenu = 'dropdown_profile-menu',
  dropdownItemMyAccount = 'dropdown-item_my-account',
  dropdownItemSignOut = 'dropdown-item_sign-out',
  containerHeader = 'header_container-header',
  linkLogo = 'header_link-logo',
  imageLogo = 'header_image-logo',
  linkCustomerSupportPhone = 'header_link-customer-support-phone',
}

export enum QaMyAccountPage {
  buttonDetailsInfo = 'my-account-page_button-',
}

export enum QaAccountDetailsPage {
  textTitle = 'account-details-page_text-title',
  textCardTitle = 'account-details-page_text-card-title-',
  textCardSubtitle = 'account-details-page_text-card-subtitle-',
  buttonUpdate = 'account-details-page_button-update-',
}

export enum QaUpdateEmailModal {
  modalUpdateEmail = 'modal-upd-email_modal',
  textTitle = 'modal-upd-email_text-title',
  buttonSaveChanges = 'modal-upd-email_button-save-changes',
  buttonCancel = 'modal-upd-email_button-cancel',
  textToastError = 'modal-upd-email_text_toast-error',
}

export enum QaUpdatePasswordModal {
  modalUpdatePassword = 'modal-upd-password_modal',
  inputCurrentPassword = 'modal-upd-password_input-current-password',
  inputNewPassword = 'modal-upd-password_input-new-password',
  inputConfirmNewPassword = 'modal-upd-password_input-confirm-new-password',
  buttonSaveChanges = 'modal-upd-password_button-save-changes',
  alertInputErrorMessage = 'modal-upd-password_error-',
}

export enum QaPasswordManagerPage {
  buttonAddPassword = 'passwords-page_button-add-password',
  buttonSearchPassword = 'passwords-page_button-search-password',
  inputSearchPassword = 'passwords-page_input-search-password',
  buttonPasswordContainers = 'passwords-page_button-password-containers',
  buttonPasswordCard = 'passwords-page_button-password-card_',
  dropdownPasswordCard = 'passwords-page_dropdown-password-card_',
  textTitleNoPasswords = 'passwords-page_title_no_passwords',
  linkMorePasswords = 'passwords-page_link-more_passwords',
  textPasswordCount = 'passwords-page_password-count',
}

export enum QaPasswordManagerDetailsPage {
  textAccountTitle = 'pm-details-page_account-title',
  textWebsite = 'pm-details-page_website',
  textUsername = 'pm-details-page_username',
  textPassword = 'pm-details-page_password',
  textNotes = 'pm-details-page_notes',
  buttonRevealPassword = 'pm-details-page_button-reveal-password',
  buttonHidePassword = 'pm-details-page_button-hide-password',
}

export enum QaAddPasswordInPMModal {
  inputWebsiteAddress = 'modal-add-password_input-website-address',
  inputAccountName = 'modal-add-password_input-account-name',
  inputUsername = 'modal-add-password_input-username',
  inputPassword = 'modal-add-password_input-password',
  inputNotes = 'modal-add-password_input-notes',
  textPasswordStrength = 'modal-add-password_password-strength',
  buttonSaveInVault = 'modal-add-password_button-save-in-vault',
}

export enum QaDeletePasswordInPMModal {
  buttonDelete = 'modal-delete-password_button-delete',
}

export enum QAConvertToPayModal {
  buttonBillingOffer = 'modal-ctp_button-billing-offer',
  checkboxAgreeTerms = 'modal-ctp_checkbox-agree-terms',
  textPlanInfo = 'modal-ctp_text-plan-info',
  textPlanPrice = 'modal-ctp_text-plan-price',
}

export enum QAMyPlanPage {
  buttonKeepPlan = 'my-plan-page_button-keep-plan',
  textCompUser = 'my-plan-page_text-comp-user',
  textPreCtpUser = 'my-plan-page_text-pre-ctp-user',
  textPostCtpUser = 'my-plan-page_text-post-ctp-user',
  textPaymentInfo = 'my-plan-page_text-payment-info',
  textBillingAutoRenew = 'my-plan-page_text-auto-renew',
  checkboxAutoRenew = 'my-plan-page_checkbox-auto-renew',
  textBillingAlert = 'my-plan-page_text-billing-alert',
  textPlanExpiration = 'my-plan-page_plan-expiration',
}

export enum QaDataCollectionModal {
  inputEmail = 'component-data-collection_input-email',
  inputFirstName = 'component-data-collection_input-first-name',
  inputMiddleName = 'component-data-collection_input-middle-name',
  inputLastName = 'component-data-collection_input-last-name',
  dropdownSuffix = 'component-data-collection_dropdown-suffix',

  inputAddress = 'component-data-collection_input-address',
  inputSuite = 'component-data-collection_input-suite',
  inputCity = 'component-data-collection_input-city',
  dropdownState = 'component-data-collection_dropdown-state',
  inputZip = 'component-data-collection_input-zip',

  inputBirthdate = 'component-data-collection_input-birthdate',
  inputPhoneNumber = 'component-data-collection_input_phone',
  inputSsn = 'component-data-collection_input_ssn',
  inputSSNConfirm = 'component-data-collection_input-ssn-confirm',
}

export enum QAEnrollmentPage {
  inputCode = 'enrollment-page_input-',
  buttonRedeemCode = 'enrollment-page_button-redeem-code',
  textRedeemCodeError = 'enrollment-page_text-redeem-code-error',

  textInputPassword = 'enrollment-page_input-password',
  textInputConfirmPassword = 'enrollment-page_input-confirm-password',
  buttonCreateAccount = 'enrollment-page_button-create-account',
  textPasswordHints = 'enrollment-page_text-password-hints',
  textTermsOfService = 'enrollment-page_text-terms-of-service',

  textPasswordHint_item = 'enrollment-page_text-password-hint-',

  checkboxEmailOptIn = 'enrollment-page_checkbox-email-opt-in',
  textEmailOptIn = 'enrollment-page_text-email-opt-in',

  buttonGoDashboard = 'enrollment-page_button-go-dashboard',
  textPlanSummaryDescription = 'enrollment-page_text-plan-summary-description',
  textPlanSummary = 'enrollment-page_text-plan-summary',
}

export enum QaForgotPasswordPage {
  textTitle = 'forgot-password-page_text-title',
  textDescription = 'forgot-password-page_text-description',
  textInputLabel = 'forgot-password-page_text-input-label-',

  buttonReturnToSignIn = 'forgot-password-page_button-return-to-sign-in',
  buttonSubmit = 'forgot-password-page_button-submit',
}

export enum QaResetPasswordPage {
  textTitle = 'reset-password-page_text-title',
  textDescription = 'reset-password-page_text-description',

  inputPassword = 'reset-password-page_input-password',
  inputConfirmPassword = 'reset-password-page_input-confirm-password',

  textSignInTermsAndPolicy = 'reset-password-page_text-sign-in-terms-and-policy',
  linkTermsOfService = 'reset-password-page_link-terms-of-service',
  linkPrivacyPolicy = 'reset-password-page_link-privacy-policy',

  buttonSignIn = 'reset-password-page_button-sign-in',
}

export enum QaCheckEmailPage {
  textTitle = 'check-email-page_text-title',
  textDescription = 'check-email-page_text-description',

  buttonReturnToSignIn = 'check-email-page_button-return-to-sign-in',
}

export enum QaVerifyTokenPage {
  imageVerifyUser = 'verify-token-page_image-verify-user',
  textTitle = 'verify-token-page_text-title',
  alertErrorMessage = 'verify-token-page_alert-error-message',
  buttonReturnToSignIn = 'verify-token-page_button-return-to-sign-in',
}

export enum QaCreditCardCapture {
  buttonCompleteSetup = 'credit-card-capture_button-complete-setup',
  buttonSkipSetup = 'credit-card-capture_button-skip-setup',
  checkboxAutoRenewAgree = 'credit-card-capture_checkbox-auto-renew-agree',
  textModalDescription = 'credit-card-capture_text-modal-description',
  textModalTitle = 'credit-card-capture_text-modal-title',
  textBanner = 'credit-card-capture_text-banner',
}

export enum QaRecoveryKeyModal {
  textTitle = 'recovery-key-modal_text-title',
  textErrorMessage = 'recovery-key-modal_error-message',
  inputRecoveryKey = 'recovery-key-modal_input-recovery-key',
  buttonCancel = 'recovery-key-modal_button-cancel',
  buttonContinue = 'recovery-key-modal_button-continue',
}

export enum QaCreateMasterPasswordModal {
  textTitle = 'create-master-password-modal_text-title',
  textDescription = 'create-master-password-modal_text-description',
  inputMasterPassword = 'create-master-password-modal_input-master-password',
  inputConfirmMasterPassword = 'create-master-password-modal_input-confirm-master-password',
  textMasterPasswordHintItem = 'create-master-password-modal_text-password-hint-',
  buttonCancel = 'create-master-password-modal_button-cancel',
  buttonContinue = 'create-master-password-modal_button-continue',
}

export enum QaRecoveryKeyDownloadModal {
  containerModal = 'recovery-key-download-modal_container-modal',
  textTitle = 'recovery-key-download-modal_text-title',
  textDescription = 'recovery-key-download-modal_text-description',
  textRecoveryKeyLabel = 'recovery-key-download-modal_text-recovery-key-label',
  fieldRecoveryKey = 'recovery-key-download-modal_field-recovery-key',
  iconCopy = 'recovery-key-download-modal_icon-copy',
  buttonDownloadAndFinish = 'recovery-key-download-modal_button-download-and-finish',
}

export enum QaPasswordDefensePage {
  textPageTitle = 'password-defense-page_text-page-title',
  textPageDescription = 'password-defense-page_text-page-description',

  // Passwords Card Locators
  containerPasswordsCard = 'password-defense-page_container-passwords-card',
  iconPasswords = 'password-defense-page_icon-passwords',
  textTitlePasswordCard = 'password-defense-page_text-password-card-title',
  textDescriptionPasswordCard = 'password-defense-page_text-password-card-description',
  containerWebsiteLogos = 'password-defense-page_container-website-logos',

  // "For this device" section Locators
  textTitleThisDevice = 'password-defense-page_text-title-this-device',
  iconPasswordDefenseThisDevice = 'password-defense-page_icon-password-defense-this-device',
  textSubtitleThisDevice = 'password-defense-page_text-subtitle-this-device',
  textDescriptionThisDevice = 'password-defense-page_text-description-this-device',
  containerPlatformsThisDevice = 'password-defense-page_container-platforms-this-device',
  buttonInstall = 'password-defense-page_button-install',
  textAlreadyInstalled = 'password-defense-page_text-already-installed',
  buttonLoginIntoPm = 'password-defense-page_button-login-into-pm',

  // "For mobile device" section Locators
  textTitleMobileDevice = 'password-defense-page_text-title-mobile-device',
  iconPasswordDefenseMobileDevice = 'password-defense-page_icon-password-defense-mobile-device',
  textSubtitleMobileDevice = 'password-defense-page_text-subtitle-mobile-device',
  textDescriptionMobileDevice = 'password-defense-page_text-description-mobile-device',
  containerPlatformsMobileDevice = 'password-defense-page_container-platforms-mobile-device',
  qrCodeMobileDevice = 'password-defense-page_qr-code-mobile-device',
}

export enum QaVpnInTouchPage {
  textPageTitle = 'vpn-in-touch-page_text-page-title',
  textPageDescription = 'vpn-in-touch-page_text-page-description',

  // Get VPN In Touch section
  containerGetVpnInTouch = 'vpn-in-touch-page_container-get-vpn-in-touch',
  iconVpnInTouch = 'vpn-in-touch-page_icon-vpn-in-touch',
  textTitleGetVpnInTouch = 'vpn-in-touch-page_text-title-get-vpn-in-touch',
  textDescriptionGetVpnInTouch = 'vpn-in-touch-page_text-description-get-vpn-in-touch',
  textUserEmail = 'vpn-in-touch-page_text-user-email',
  textAvailableOn = 'vpn-in-touch-page_text-available-on',
  containerOsPlatforms = 'vpn-in-touch-page_container-os-platforms',
  buttonInstall = 'vpn-in-touch-page_button-install',

  // Login into VPN section
  buttonLoginIntoVpn = 'vpn-in-touch-page_button-login-into-vpn',

  // What Does VPN Do Section
  textTitleWhatDoesVpnDo = 'vpn-in-touch-page_text-title-what-does-vpn-do',
  containerItemWhatDoesVpnDo = 'vpn-in-touch-page_container-item-what-does-vpn-do',
  iconItemWhatDoesVpnDo = 'vpn-in-touch-page_icon-what-does-vpn-do_item-',
  textTitleItemWhatDoesVpnDo = 'vpn-in-touch-page_text-title-what-does-vpn-do_item-',
  textDescriptionItemWhatDoesVpnDo = 'vpn-in-touch-page_text-description-what-does-vpn-do_item-',
}

export enum QADashboardPageCreditScore {
  cardCreditScore = 'dashboard-page_credit-score_card',
  iconSpeedometer = 'dashboard-page_credit-score_icon-speedometer',
  testCardTitle = 'dashboard-page_credit-score_card-title',
  textLastUpdated = 'dashboard-page_credit-score_text-last-updated',
  buttonViewFullReport = 'dashboard-page_credit-score_button-view-full-report',

  // Credit Score card when Identity Verification is not completed
  iconVerifyIdentity = 'dashboard-page_credit-score_icon-verify-identity',
  textVerifyIdentity = 'dashboard-page_credit-score_text-verify-identity',
  buttonVerifyIdentity = 'dashboard-page_credit-score_button-verify-identity',
}

export enum QaCreditScorePage {
  textPageTitle = 'credit-score-page_text-page-title',
  textPageDescription = 'credit-score-page_text-page-description',
  iconTime = 'credit-score-page_icon-time',
  textLastUpdatedDate = 'credit-score-page_text-last-updated-date',

  // Credit Score Graph
  scoreGraphContainer = 'credit-score-page_container-score-graph',
  bureauIcon = 'credit-score-page_icon-bureau-',
  textScore = 'credit-score-page_text-score',
  textScoreLabel = 'credit-score-page_text-score-label',
  textScoreProgress = 'credit-score-page_text-score-progress',
  barProgressIndicatorContainer = 'credit-score-page_bar-progress-indicator-container',
  barProgressIndicator = 'credit-score-page_bar-progress-indicator-',
  barProgressCircle = 'credit-score-page_bar-progress-circle-',

  textScoreMinRange = 'credit-score-page_text-score-min-range',
  textScoreMaxRange = 'credit-score-page_text-score-max-range',
  divider = 'credit-score-page_divider',
  barLegendIndicator = 'credit-score-page_bar-legend-indicator-',
  textLegendLabel = 'credit-score-page_text-legend-label-',
  textLegendRange = 'credit-score-page_text-legend-range-',

  // Credit Score Factors
  textTitleScoreFactors = 'credit-score-page_text-title-score-factors',
  containerFactorsItems = 'credit-score-page_container-factors-items',
  textFactorTitle = 'credit-score-page_text-factor-title',
  textFactorStatusBadge = 'credit-score-page_text-factor-status-badge',
  containerFactorContent = 'credit-score-page_container-factor-content',
  textTitleExplanationSection = 'credit-score-page_text-title-explanation-section',
  textDescriptionExplanationSection = 'credit-score-page_text-description-explanation-section',
  textTitleWhatYouCanDoSection = 'credit-score-page_text-title-what-you-can-do-section',
  textDescriptionWhatYouCanDoSection = 'credit-score-page_text-description-what-you-can-do-section',

  // Credit Score page in unavailable state
  containerUnavailableState = 'credit-score-page_container-unavailable-state',
  bureauIconUnavailableState = 'credit-score-page_icon-bureau-unavailable-state',
  textTitleUnavailableState = 'credit-score-page_text-title-unavailable-state',
  textDescriptionUnavailableState = 'credit-score-page_text-description-unavailable-state',
  textAssistanceUnavailableState = 'credit-score-page_text-assistance-unavailable-state',

  // Credit Score page when Identity Verification is not completed
  containerVerifyIdentity = 'credit-score-page_container-verify-identity',
  iconUserCheck = 'credit-score-page_icon-user-check',
  textTitleVerifyIdentity = 'credit-score-page_text-title-verify-identity',
  textDescriptionVerifyIdentity = 'credit-score-page_text-description-verify-identity',
  buttonVerifyNow = 'credit-score-page_button-verify-now',
}

export enum QaCreditTrackerPage {
  textPageTitle = 'credit-tracker-page_text-page-title',
  textPageDescription = 'credit-tracker-page_text-page-description',
  iconTime = 'credit-tracker-page_icon-time',
  textLastUpdatedDate = 'credit-tracker-page_text-last-updated-date',

  // Score Tracker Graph
  containerScoreTrackerGraph = 'credit-tracker-page_container-score-tracker-graph',
  containerScoreTracker = 'credit-tracker-page_container-score-tracker',
  divider = 'credit-tracker-page_divider',

  // Score history table
  textTitleScoreHistory = 'credit-tracker-page_text-title-score-history',
  containerScoreHistoryTable = 'credit-tracker-page_container-score-history-table',
}
